/**
 * External Dependencies
 */
import 'jquery';
import 'foundation-sites';

import Swiper, { Navigation, Pagination, EffectFade, Scrollbar } from 'swiper';
Swiper.use([Navigation, Pagination, EffectFade, Scrollbar]);

$(document).ready(() => {
  	$('.hamburger').on('click', function(e){
		e.preventDefault();
		$('.hamburger, .overlay-menu, body').toggleClass('is-active');
	});

	new Swiper('.home-swiper', {
        loop: true,
        centeredSlides: true,
        speed: 600,
        simulateTouch: false,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        navigation: {
            nextEl: '.home-swiper .next',
            prevEl: '.home-swiper .prev',
        },
    });

	//Swiper
	new Swiper('.standard-swiper', {
		loop: true,
		centeredSlides: true,
		simulateTouch: false,
		speed: 600,
		pagination: {
			el: '.standard-swiper .swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		navigation: {
			nextEl: '.nav .next',
			prevEl: '.nav .prev',
		},
	});

	//Swiper
	new Swiper('.card-swiper', {
		speed: 600,
		slidesPerView: 1,
		spaceBetween: 15,
		breakpoints: {
			480: {
				slidesPerView: 1,
				spaceBetween: 20,
			},
			640: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			1000: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
		},
		pagination: {
			el: '.card-swiper .swiper-pagination',
			type: 'bullets',
			clickable: true,
		},
		navigation: {
			nextEl: '.nav .next',
			prevEl: '.nav .prev',
		},
		scrollbar: {
		    el: '.swiper-scrollbar',
		    draggable: true,
		},
	});

	$(window).scroll(function() {
	    if ($(this).scrollTop() > 100){
	        $('header').addClass("stuck");
	    } else {
	        $('header').removeClass("stuck");
	    }
	});

	$('a[href*="#"]:not([href="#"])').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
		  var target = $(this.hash);
		  target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
		  if (target.length) {
		    $('html, body').animate({
		      scrollTop: target.offset().top
		    }, 1000);
		    return false;
		  }
		}
	});

	$(document).foundation();
});

$(window).load(() => {
	$('.main-navigation').show();
});
